// Helper functions to calculate date ranges with local time

export const isToday = (date: Date) => {
  const today = new Date();
  return (
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
  );
};

export const isYesterday = (date: Date) => {
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  return (
    date.getDate() === yesterday.getDate() &&
    date.getMonth() === yesterday.getMonth() &&
    date.getFullYear() === yesterday.getFullYear()
  );
};

export const isWithinLastNDays = (date: Date, n: number) => {
  const today = new Date();
  const previousN = new Date();
  previousN.setDate(today.getDate() - n);
  return date >= previousN && date < today;
};
